"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.informErrorList = informErrorList;
exports.informHistoryList = informHistoryList;
exports.informInfo = informInfo;
exports.informJSONInfo = informJSONInfo;
exports.informLateList = informLateList;
exports.informNormalList = informNormalList;

var _request = _interopRequireDefault(require("@/utils/request"));

// 获取新的报告列表
function informLateList(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/inform/lately_list',
    method: 'get',
    params: params
  });
} // 最近打开的报告列表


function informHistoryList(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/inform/history_list',
    method: 'get',
    params: params
  });
} // 上报失败报告列表


function informErrorList(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/inform/error_list',
    method: 'get',
    params: params
  });
} // 项目报告列表


function informNormalList(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/inform/normal_list',
    method: 'get',
    params: params
  });
} // 获取报告的详情json文件


function informJSONInfo(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/inform/info',
    method: 'get',
    params: params
  });
}

function informInfo(params) {
  return (0, _request.default)({
    url: '/laya_air_pro/inform/detail',
    method: 'get',
    params: params
  });
}